import { useEffect } from 'react';
import { useSplash } from './SplashContext';
import { isReactivationInProgress } from '../../utils/billing/reactivationInProgress';
import { ldLog } from '../../utils/ui/loginDebug';
import { useSignOutSplashActive } from './signOutSplash';
import { isBootGateExemptPath } from '../../utils/ui/bootGateExemptPaths';

// Holds the splash during the FIRST route-chunk load with `immediate`, so the
// boot → lazy-route handoff can't dip into a fade-out it must immediately
// reverse (the deferred-signal flicker). Once the first route commits, later
// chunk loads fall back to the default deferred (180ms flash-protected) splash.
let bootRouteSettled = false;
export default function BootRouteSplashTrigger() {
  // KAN-877: a suspended-screen reactivation (card -> celebration) owns the screen; the splash must not re-raise under it.
  // While the quiet sign-out veil is up, the Login chunk's Suspense must not flip it back to the brand splash.
  // SUBSCRIBED (code review, 2026-10-21): a one-shot read left this signal's veil flag stale after
  // the cover released; subscribing keeps the store's `veil` derivation honest (the overlay's own
  // latch decides the look while it is visible).
  const signOutVeil = useSignOutSplashActive();
  // KAN-1188: a customer page (/estimate, /unsubscribe) never shows the CrewVex splash —
  // while its chunk loads the page's own ground shows (painted on <body> by public/splash-phase.js),
  // then its own loading card.
  const customerPage = typeof window !== 'undefined' && isBootGateExemptPath(window.location.pathname);
  useSplash(!customerPage && !isReactivationInProgress(), { immediate: !bootRouteSettled, veil: signOutVeil });
  useEffect(() => { ldLog('suspense.boot', { ev: 'mount' }); return () => { ldLog('suspense.boot', { ev: 'unmount' }); }; }, []);
  useEffect(() => () => { bootRouteSettled = true; }, []);
  return null;
}
